class Timer {
    constructor(parent) {
      this.parent = parent;
      if (!this.parent) {
        return;
      }
      this.init();
    }
  
  
    checkStartTime = () => {
      let parent = this.parent;
      const countDownDate = new Date(simply.timerData.startdate).getTime();
      const now = Date.now();
      const distance = now - countDownDate;
      if (distance < 0) {
        parent.classList.add('hidden');
      }
    }
  
    timerLoad = () => {
      let parent = this.parent;
  
      // Set the date we're counting down to
      const countDownDate = new Date(simply.timerData.enddate).getTime();
  
      // Update the countdown every 1 second
      const timerInterval = setInterval(() => {
        const now = Date.now();
  
        // Calculate the distance between now and the countdown date
        const distance = countDownDate - now;
  
        if (distance < 0) {
          clearInterval(timerInterval);
          parent.classList.add('hidden');
          document.getElementById('demo').textContent = 'EXPIRED';
          return;
        }
  
        // Time calculations for days, hours, minutes, and seconds
        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);
  
        // hours += days * 24;
  
        // Output the result
        qs('.time-stamp .days', parent).textContent = String(days).padStart(2, '0');
        qs('.time-stamp .hours', parent).textContent = String(hours).padStart(2, '0');
        qs('.time-stamp .minutes', parent).textContent = String(minutes).padStart(2, '0');
        qs('.time-stamp .seconds', parent).textContent = String(seconds).padStart(2, '0');
      }, 1000);
  
    }
  
    init = () => {
      this.checkStartTime();
      this.timerLoad();
    }
  }
  
  document.addEventListener('DOMContentLoaded', () => {
    new Timer(qs('.offer-ends-in-js'));
  }, false);